'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PromotionsprogrammtypSchema = {
  title: 'Promotionsprogrammtyp',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/promotionsprogrammtyp.js
// module id = XgGg
// module chunks = 0